import angular from 'angular';
import utils from 'utils/lsp-utils-service';
import lspBulletPlaceholderDirective from './lsp-bullet-placeholder-directive';

export default angular.module('lsp-bullet-placeholder', []).directive('lspBulletPlaceholder', utils.createNgFactory(lspBulletPlaceholderDirective));



// WEBPACK FOOTER //
// ./src/modules/utils/lsp-bullet-placeholder/lsp-bullet-placeholder-module.js